/**
 * File: assets/breed-checker-modal.js
 * Bootstrap / init only (NO CSS).
 */
(() => {
  const NS = '[BreedModal]';
  const log = (...args) => console.log(NS, ...args);

  const FORCE_PARAM = 'breed_modal';
  const SHOWN_KEY = 'breed_modal_shown_v2';
  const SELECTED_BREED_KEY = 'selected_breed_v2';

  const heroImg = window.WOOPF_MODAL_IMG_URL || '';
  const FLOAT_ICON_URL = window.WOOPF_FACE_ICON_URL || '/cdn/shop/t/0/assets/face.svg';

  const BREEDS_ASSET_URL = window.WOOPF_BREEDS_URL || '/cdn/shop/t/0/assets/breeds-by-size.json';
  const BREEDS_ASSET_URL_FALLBACK = '/cdn/shop/t/0/assets/breeds-by-size.json';
  const WEIGHT_BREEDS_ASSET_URL = window.WOOPF_WEIGHT_BREEDS_URL || '/cdn/shop/t/0/assets/breeds-by-weight.json';
  const BULK_BREEDS_ASSET_URL = window.WOOPF_BULK_BREEDS_URL || '/cdn/shop/t/0/assets/breeds-by-bulk.json';

  const BED_SIZE_URLS = {
    small:
      '/collections/sleep-comfort?filter.v.t.shopify.accessory-size=gid%3A%2F%2Fshopify%2FTaxonomyValue%2F2913',
    medium:
      '/collections/sleep-comfort?filter.v.t.shopify.accessory-size=gid%3A%2F%2Fshopify%2FTaxonomyValue%2F2914',
    large:
      '/collections/sleep-comfort?filter.v.t.shopify.accessory-size=gid%3A%2F%2Fshopify%2FTaxonomyValue%2F2915',
    extra_large:
      '/collections/sleep-comfort?filter.v.t.shopify.accessory-size=gid%3A%2F%2Fshopify%2FTaxonomyValue%2F2916',
  };

  const GEAR_SIZE_URLS = {
    small:
      '/collections/walking-gear?filter.v.t.shopify.accessory-size=gid%3A%2F%2Fshopify%2FTaxonomyValue%2F2913',
    medium:
      '/collections/walking-gear?filter.v.t.shopify.accessory-size=gid%3A%2F%2Fshopify%2FTaxonomyValue%2F2914',
    large:
      '/collections/walking-gear?filter.v.t.shopify.accessory-size=gid%3A%2F%2Fshopify%2FTaxonomyValue%2F2915',
  };

  const PLAY_SIZE_URLS = {
    medium:
      '/collections/play-enrichment?filter.v.t.shopify.accessory-size=gid%3A%2F%2Fshopify%2FTaxonomyValue%2F2914',
    large:
      '/collections/play-enrichment?filter.v.t.shopify.accessory-size=gid%3A%2F%2Fshopify%2FTaxonomyValue%2F2915',
  };

  const SIZE_OPTION_VALUE_MAP = {
    small: 'Small',
    medium: 'Medium',
    large: 'Large',
    extra_large: 'Extra Large',
  };

  const FALLBACK_BREEDS = [
    'Affenhuahua',
    'Affenpinscher',
    'Australian Terrier',
    'Bichon Frise',
    'Biewer Terrier',
    'Bolognese',
    'Border Terrier',
    'Brussels Griffon',
    'Cairn Terrier',
    'Cavapoo',
    'Cheagle',
    'Chi Chi',
    'Chi-Poo',
    'Chigi',
    'Chihuahua',
    'Chilier',
    'Chion',
    'Chipin',
    'Chiweenie',
    'Chorkie',
    'Coton de Tulear',
    'Dorkie',
    'English Toy Spaniel',
    'Havanese',
    'Japanese Chin',
    'Kyi-Leo',
    'Lancashire Heeler',
    'Lhasa Apso',
    'Lhasapoo',
    'Maltese',
    'Maltese Shih Tzu',
    'Maltipoo',
    'Miniature Pinscher',
    'Morkie',
    'Norfolk Terrier',
    'Norwich Terrier',
    'Papillon',
    'Papipoo',
    'Peekapoo',
    'Pekingese',
    'Pocket Beagle',
    'Pomapoo',
    'Pomchi',
    'Pomeagle',
    'Pomeranian',
    'Portuguese Podengo Pequeno',
    'Puginese',
    'Shichon',
    'Shih Tzu',
    'Shiranian',
    'Shorkie',
    'Silky Terrier',
    'Tibetan Spaniel',
    'Toy Fox Terrier',
    'West Highland White Terrier',
    'Yorkipoo',
    'Yorkshire Terrier',
  ];

  const COLLECTION_GRID_SECTION_ID =
    window.WOOPF_COLLECTION_GRID_SECTION_ID || 'main-collection-product-grid';

  const FLOAT_BTN_ID = 'woopf-breed-float-btn';

  function hasForceFlag() {
    try {
      return new URLSearchParams(location.search).has(FORCE_PARAM);
    } catch {
      return false;
    }
  }

  /**
   * HOME-06 (#73). The three breed JSON files (25,350 bytes) used to load on DOMContentLoaded on
   * every page, for a modal whose only entry point is the floating button. They now load the first
   * time that button is touched - warmed on hover where there is a pointer, awaited on click where
   * there is not. `ui.bind` is what wires the modal's own controls and sets overlay.__applyBreed,
   * so it has to finish before ui.open runs; every path below goes through ensureBreeds first.
   */
  let breedsReady = null;

  function ensureBreeds(core, ui) {
    if (!breedsReady) {
      breedsReady = Promise.all([core.loadBreeds(), core.loadWeightBreeds(), core.loadBulkBreeds()])
        .then(([loaded]) => {
          ui.bind(core.uniqueSorted(loaded.list));
        })
        .catch((error) => {
          // Let the next interaction try again rather than leaving a dead button.
          breedsReady = null;
          throw error;
        });
    }

    return breedsReady;
  }

  function init() {
    if (!window.WOOPF_BREED_MODAL_CORE?.createCore) {
      console.error(NS, 'Missing core: WOOPF_BREED_MODAL_CORE.createCore');
      return;
    }

    if (!window.WOOPF_BREED_MODAL_UI?.createUI) {
      console.error(NS, 'Missing ui: WOOPF_BREED_MODAL_UI.createUI');
      return;
    }

    window.WOOPF_BREED_MODAL_STYLES?.inject?.();

    const core = window.WOOPF_BREED_MODAL_CORE.createCore({
      shownKey: SHOWN_KEY,
      selectedBreedKey: SELECTED_BREED_KEY,

      breedsUrl: BREEDS_ASSET_URL,
      breedsUrlFallback: BREEDS_ASSET_URL_FALLBACK,
      weightBreedsUrl: WEIGHT_BREEDS_ASSET_URL,
      bulkBreedsUrl: BULK_BREEDS_ASSET_URL,

      fallbackBreeds: FALLBACK_BREEDS,

      bedSizeUrls: BED_SIZE_URLS,
      gearSizeUrls: GEAR_SIZE_URLS,
      playSizeUrls: PLAY_SIZE_URLS,

      sizeOptionValueMap: SIZE_OPTION_VALUE_MAP,
      collectionGridSectionId: COLLECTION_GRID_SECTION_ID,
      variantOptionNameHints: ['size'],
      maxVariantFetch: 30,
    });

    const ui = window.WOOPF_BREED_MODAL_UI.createUI(
      {
        heroImg,
        floatBtnId: FLOAT_BTN_ID,
        floatIconUrl: FLOAT_ICON_URL,
      },
      core
    );

    const openWhenReady = () => ensureBreeds(core, ui).then(() => ui.open());

    window.WOOPF_BREED_MODAL = window.WOOPF_BREED_MODAL || {};
    window.WOOPF_BREED_MODAL.open = openWhenReady;
    window.WOOPF_BREED_MODAL.close = ui.close;

    if (ui.floatBtn) {
      // Warm on hover so a mouse user waits for nothing; touch falls through to the click.
      ui.floatBtn.addEventListener('pointerenter', () => ensureBreeds(core, ui).catch(() => {}), {
        once: true,
      });
      ui.floatBtn.addEventListener('click', () => openWhenReady().catch(() => {}));
    }

    // The ?breed_modal deep link stays switched off, as it was. If it is ever re-enabled it has to
    // go through openWhenReady(), which loads the data before it opens:
    // if (hasForceFlag()) {
    //   openWhenReady();
    //   log('Forced open via ?breed_modal');
    // }
  }

  document.addEventListener('DOMContentLoaded', init);
})();
